import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Popper from '@components/Popper/index';

const messages = defineMessages({
  sync: {
    id: 'terraSync.popover',
    defaultMessage:
      'If data from your device is not updating, please try opening its associated app on your phone. From time to time, these apps go into sleep mode and do not sync the data. Opening the app will wake it up and sync the missing data.',
  },
  title: {
    id: 'terraSync.button',
    defaultMessage: 'Not seeing your latest data?',
  },
});

function TerraSyncButton({ style }: { style?: React.CSSProperties }) {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState<boolean>(false);

  const handleClick = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  return (
    <div style={{ width: '100%', textAlign: 'right', ...style }}>
      <Popper
        buttonContent={<Typography>{formatMessage(messages.title)}</Typography>}
        onClick={handleClick}
        onClose={handleClose}
        open={open}
        popoverContent={formatMessage(messages.sync)}
        type="link"
      />
    </div>
  );
}

export default TerraSyncButton;
